import { preferedLanguage } from '../../components/LanguageSwitcher/preferredLanguage';

export function getApiLanguage() {
  const language = preferedLanguage();

  if (language === 'zh-Hant') return 'zh-hant';
  if (language === 'zh-Hans') return 'zh-hans';

  return language;
}
